import { atom } from 'recoil';
import { GroupCartItem } from '~/types';

const groupItems = atom<Array<GroupCartItem>>({
  key: 'groupItems',
  default: [],
});

export default groupItems;
